import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function EntryTollIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "white";
  const color = props.htmlColor || defaultColor;
  return (
      <SvgIcon
          {...props}
          htmlColor={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 40 40"
          xmlSpace="preserve"
          enableBackground="new 0 0 40 40"
          titleAccess="Entry">
          <g filter="url(#filter0_d_1370_6289)">
              <circle cx="20" cy="20" r="16" fill="white"/>
              <circle cx="20" cy="20" r="13" stroke="#0E893C" strokeWidth="6"/>
          </g>
          <defs>
              <filter id="filter0_d_1370_6289" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                 result="hardAlpha"/>
                  <feOffset/>
                  <feGaussianBlur stdDeviation="2"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1370_6289"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1370_6289" result="shape"/>
              </filter>
          </defs>
      </SvgIcon>
  );
}
